export enum ListStyle 
{
    StackedTwoColumn = 0,
    StackedOneColumn = 1,
    HorizontalScroll = 2
}